"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApprovalServiceLive = void 0;
const HttpProvider_1 = require("../utils/HttpProvider");
class ApprovalServiceLive {
    async getApprovalConfig(companyId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/approval-config`);
        return response.data;
    }
    async setApprovalConfig(companyId, config) {
        const response = await HttpProvider_1.httpProvider.put(`/company/${companyId}/approval-config`, config);
        return response.data;
    }
    async getUserRoles(companyId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/user-roles`);
        return response.data;
    }
    async updateUserRoles(companyId, userId, roles) {
        const response = await HttpProvider_1.httpProvider.patch(`/company/${companyId}/user-roles/${userId}/roles`, { roles });
        return response.data;
    }
    async approveAndExecute(requestId) {
        const response = await HttpProvider_1.httpProvider.post(`/approvals/${requestId}/approve`, {});
        return response.data;
    }
    async getApproval(requestId) {
        const response = await HttpProvider_1.httpProvider.get(`/approvals/${requestId}`);
        return response.data;
    }
    async listPendingApprovals(companyId) {
        const url = companyId ? `/approvals/pending?companyId=${companyId}` : "/approvals/pending";
        const response = await HttpProvider_1.httpProvider.get(url);
        return response.data;
    }
    async listRejectedApprovals(companyId) {
        const response = await HttpProvider_1.httpProvider.get(`/approvals/rejected?companyId=${companyId}`);
        return response.data;
    }
    async rejectApproval(requestId, reason) {
        const response = await HttpProvider_1.httpProvider.post(`/approvals/${requestId}/reject`, { reason });
        return response.data;
    }
    async cancelApproval(requestId) {
        const response = await HttpProvider_1.httpProvider.post(`/approvals/${requestId}/cancel`, {});
        return response.data;
    }
    async resubmitAction(companyId, actionType, actionRef, payload, files) {
        const url = `/company/${companyId}/actions/${actionType}/${actionRef}/resubmit`;
        // When the caller supplies attachments (announcement Edit & resubmit), send multipart so the new
        // files reach the resubmit endpoint's upload handler; otherwise keep the plain JSON body.
        if (files && files.length > 0) {
            const formData = new FormData();
            Object.entries(payload).forEach(([key, value]) => {
                formData.append(key, value == null ? "" : String(value));
            });
            files.forEach((file) => formData.append("files", file, file.name));
            const response = await HttpProvider_1.httpProvider.post(url, formData);
            return response.data;
        }
        const response = await HttpProvider_1.httpProvider.post(url, payload);
        return response.data;
    }
    async deleteRejectedDraft(companyId, actionType, actionRef) {
        const response = await HttpProvider_1.httpProvider.delete(`/company/${companyId}/actions/${actionType}/${actionRef}`);
        return response.data;
    }
    async getPendingApprovalCount(companyId) {
        const url = companyId ? `/approvals/pending?companyId=${companyId}` : "/approvals/pending";
        const response = await HttpProvider_1.httpProvider.get(url);
        const list = response.data?.payload ?? [];
        const actionable = Array.isArray(list) ? list.filter((r) => r.canApprove) : [];
        return { ...response.data, payload: { count: actionable.length } };
    }
    async notifyApprovers(requestId, approverUserId) {
        const response = await HttpProvider_1.httpProvider.post(`/approvals/${requestId}/notify-approvers`, { approverUserId });
        return response.data;
    }
    async getRejectedDraft(companyId, actionType, actionRef) {
        const query = actionRef ? `?actionRef=${encodeURIComponent(actionRef)}` : "";
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/actions/${actionType}/rejected-draft${query}`);
        return response.data;
    }
}
exports.ApprovalServiceLive = ApprovalServiceLive;
//# sourceMappingURL=ApprovalServiceLive.js.map